import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { palette } from '@dev/ee-components';
import styled from 'styled-components';

import useMobile from '@/services/hooks/useMobile';

import { ViewEmailStart } from '@/store/emails/actions';

import Header from './Header';
import EmailInfoRows from './EmailInfoRows';
import EventHistoryChart from './EventHistoryChart';
import { ContactEventHistoryProps } from './ContactEventHistoryInterface';

type BoardProps = {
    isMobile: boolean;
};

const Board = styled.div<BoardProps>`
    padding: ${(props) => (props.isMobile ? '24px 20px' : '24px 48px')};
    border: 1px solid ${palette.gray[3]};
    border-radius: 4px;
`;

const ContactEventHistory = (props: ContactEventHistoryProps): JSX.Element => {
    const dispatch = useDispatch();
    const isMobile = useMobile();

    useEffect(() => {
        dispatch(ViewEmailStart(props.msgId));
    }, []);

    return (
        <div>
            <Header />
            <Board isMobile={isMobile}>
                <EmailInfoRows />
                <EventHistoryChart />
            </Board>
        </div>
    );
};

export default ContactEventHistory;
